/**
 * Pingo — desktop mega-menu card carousel.
 *
 * Native Horizon lays the mega grid as `repeat(--menu-columns-desktop, 1fr)`,
 * so a 7th collection-image card wraps onto a second row. CSS in pingo-custom.css
 * already forces that list to a single overflowing row (≥990px). This script
 * adds prev/next arrows when the row actually overflows, and keeps them in
 * sync with scroll. Trackpad / shift-wheel still work without it.
 *
 * Native files untouched. See DECISIONS.md → Mega menu — one-row carousel.
 */
(function () {
  if (window.__pingoMegaCarouselInit) return;
  window.__pingoMegaCarouselInit = true;

  var MQ = '(min-width: 990px)';
  var SELECTOR = 'header-menu .mega-menu__list:has(.mega-menu__link-image)';
  var CARET =
    '<svg class="pingo-mega-carousel__icon" viewBox="0 0 14 14" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M11 5.5L7 9.5L3 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function isDesktop() {
    return window.matchMedia(MQ).matches;
  }

  function maxScroll(track) {
    return Math.max(0, track.scrollWidth - track.clientWidth);
  }

  function step(track) {
    var col = track.querySelector(':scope > .mega-menu__column');
    if (!col) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return col.getBoundingClientRect().width + gap;
  }

  function sync(track) {
    var wrap = track.closest('.mega-menu__grid');
    if (!wrap) return;
    var prev = wrap.querySelector('.pingo-mega-carousel__btn--prev');
    var next = wrap.querySelector('.pingo-mega-carousel__btn--next');
    if (!prev || !next) return;

    var wasScrollable = track.classList.contains('is-scrollable');
    var max = maxScroll(track);
    var scrollable = max > 2;
    track.classList.toggle('is-scrollable', scrollable);
    wrap.classList.toggle('pingo-mega-carousel--scrollable', scrollable);
    /* Peek changes card width; remeasure once after the class lands. */
    if (wasScrollable !== scrollable) {
      requestAnimationFrame(function () {
        sync(track);
      });
      return;
    }

    var left = track.scrollLeft;
    /* Hide both only when this row is not a carousel. At the ends, DISABLE
       instead of hiding: `display:none` under the cursor fires pointerleave on
       the parent <li>, and header-menu.js treats that as "left the mega menu". */
    prev.hidden = !scrollable;
    next.hidden = !scrollable;
    prev.disabled = !scrollable || left <= 2;
    next.disabled = !scrollable || left >= max - 2;
  }

  function go(track, dir) {
    var max = maxScroll(track);
    var nextLeft = Math.max(0, Math.min(max, track.scrollLeft + dir * step(track)));
    track.scrollLeft = nextLeft;
    sync(track);
  }

  function makeBtn(dir, label, track) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pingo-mega-carousel__btn pingo-mega-carousel__btn--' + dir;
    btn.setAttribute('aria-label', label);
    btn.tabIndex = -1;
    btn.hidden = true;
    btn.innerHTML = CARET;
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (btn.disabled) return;
      go(track, dir === 'next' ? 1 : -1);
    });
    /* mousedown preventDefault keeps the button from taking focus. A focus
       steal blurs the <li on:blur="/deactivate"> and header-menu.js closes
       the mega panel instead of scrolling. pointerdown stopPropagation only
       — preventDefault there can cancel the subsequent click. */
    btn.addEventListener('mousedown', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
    btn.addEventListener('pointerdown', function (event) {
      event.stopPropagation();
    });
    return btn;
  }

  function enhance(track) {
    if (!isDesktop()) return;
    var grid = track.closest('.mega-menu__grid');
    if (!grid) return;

    if (track.dataset.pingoMegaCarousel === '1') {
      sync(track);
      return;
    }

    track.dataset.pingoMegaCarousel = '1';
    track.classList.add('pingo-mega-carousel__track');
    grid.appendChild(makeBtn('prev', 'Anterior', track));
    grid.appendChild(makeBtn('next', 'Próximo', track));
    track.addEventListener(
      'scroll',
      function () {
        sync(track);
      },
      { passive: true }
    );
    sync(track);
  }

  function enhanceAll() {
    if (!isDesktop()) return;
    document.querySelectorAll(SELECTOR).forEach(enhance);
  }

  document.addEventListener(
    'pointerover',
    function (event) {
      if (event.target && event.target.closest && event.target.closest('header-menu')) {
        enhanceAll();
      }
    },
    true
  );
  document.addEventListener('focusin', function (event) {
    if (event.target && event.target.closest && event.target.closest('header-menu')) {
      enhanceAll();
    }
  });
  window.addEventListener('resize', enhanceAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }
})();
